import {useTranslation} from "react-i18next";
import facebook from '@assets/svg/review/facebook.svg';
import instagram from '@assets/svg/review/instagram.svg';
import tripadvisor from '@assets/svg/review/tripavisor.svg';
import google from '@assets/svg/review/google.svg';

const SOCIAL_LOGOS = {
  FACEBOOK: facebook,
  INSTAGRAM: instagram,
  TRIP_ADVISOR: tripadvisor,
  GOOGLE: google,
};

const SOCIAL_NAMES = {
  FACEBOOK: 'Facebook',
  INSTAGRAM: 'Instagram',
  TRIP_ADVISOR: 'Tripadvisor',
  GOOGLE: 'Google',
};

const ReviewItem = ({name, logo, url}) => {

  const redirect = () => {
    window.open(url, '_blank')
  }

  return (
    <div onClick={redirect}
         className='flex flex-row items-center align-middle border rounded-lg py-2 px-3 text-xs transition duration-300 ease-in-out cursor-pointer hover:bg-gray-100 hover:scale-[0.97]'
    >
      <img src={logo} className='w-6 h-6 mr-2' alt={name}/> {SOCIAL_NAMES[name?.toUpperCase()] || ''}
    </div>
  );
};

const Reviews = ({ businessSocials }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col space-y-3 px-4">
      <div className="mt-3 text-lg font-[600]">
        {t('leaveAReview')}
      </div>
      {/* Scrollable Container */}
      <div className="overflow-x-auto">
        <div className="inline-flex space-x-3 w-max">
          {businessSocials.map((social) => (
            <ReviewItem
              key={social.platform}
              name={social.platform}
              logo={SOCIAL_LOGOS[social.platform.toUpperCase()] || ''}
              url={social?.url}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Reviews;
